/**
 * Passwords and tokens must travel over HTTPS in production.
 * Hashing happens on the server; TLS protects the password while it is in transit.
 */

function isDevelopment(): boolean {
  return (
    import.meta.env?.DEV === true ||
    import.meta.env?.MODE === 'development' ||
    process.env.NODE_ENV === 'development'
  );
}

function isLocalHttpUrl(url: string): boolean {
  return (
    url.startsWith('http://localhost') ||
    url.startsWith('http://127.0.0.1')
  );
}

/**
 * Ensures the configured API base URL uses a safe transport for auth requests.
 * - Production: must be https://
 * - Development: allows /api (Vite proxy → HTTPS backend) or local http://
 */
export function assertSecureApiTransport(apiUrl: string): void {
  if (!apiUrl) {
    throw new Error('API URL is not configured. Set VITE_API_URL or REACT_APP_API_URL.');
  }

  // Dev proxy: browser → same-origin /api → Vite → https://localhost:7192
  if (apiUrl.startsWith('/')) {
    if (isDevelopment()) {
      return;
    }
    throw new Error('Relative API URLs are only allowed in development.');
  }

  if (apiUrl.startsWith('https://')) {
    return;
  }

  if (isLocalHttpUrl(apiUrl) && isDevelopment()) {
    console.warn(
      '[security] Local HTTP API URL in development. Production must use HTTPS.'
    );
    return;
  }

  throw new Error(
    `Insecure API URL "${apiUrl}". Login, signup, and user management require HTTPS in production.`
  );
}
